import { get, set } from 'services/storage'
import {
  SUPPORTED_GEOAREAS_IDS,
  DEFAULT_GEOAREA_ID,
  SUPPORTED_GEOAREAS,
} from './geoareas'

export const loadGeo = (): number => {
  const geo = parseInt(get('geo')() as string)
  // for kampaayers not logged or without an assigned geoarea in we default to the milan geoarea for language picking
  return SUPPORTED_GEOAREAS_IDS?.includes(geo) ? geo : DEFAULT_GEOAREA_ID
}

let _geo = loadGeo()

export const getGeo = () => _geo
export const setGeo = (geo: number) => {
  set('geo')(geo.toString())
  _geo = geo
}

export const getCurrentGeoarea = () =>
  SUPPORTED_GEOAREAS.find((g) => g.id === getGeo())!

export const getGeoLang = () => getCurrentGeoarea().country.localeCode
